<template>
  <ValidationObserver v-slot="{handleSubmit, invalid, reset}" ref="observer">
    <artisio-modal :visible="showPremiumsModal" :data="model" :title="$t('Premiums')" size="lg" @show="onShow"
                   @hidden="onHidden" @ok.prevent="handleSubmit(onSubmit)" :ok-title="$t('Submit')"
                   :is-loading="loading" scrollable modal-class="mobile-full-screen">
      <premium-tiers ref="premiumTiers" :model="model" show-minimum-premium-field/>
    </artisio-modal>
  </ValidationObserver>
</template>

<script>

  import {createNamespacedHelpers} from 'vuex';
  import ArtisioModal from "../../../../../core/components/artisio-modal/ArtisioModal";
  import PremiumTiers from "../../../../../core/components/premium-tiers/PremiumTiers";
  import _ from 'lodash';
  import PremiumsFormData from "@/modules/sales/models/PremiumsFormData.model";

  const {mapState, mapActions} = createNamespacedHelpers('reservations');

  export default {
    name: "PremiumsModal",
    components: {PremiumTiers, ArtisioModal},
    data: () => {
      return {
        loading: false,
        model: {}
      }
    },
    methods: {
      ...mapActions(['togglePremiumsModal', 'saveTermsPartialData']),
      async onSubmit() {
        let success = await this.$confirm(this.$i18n.t('Changing terms will trigger automatic recalculation of all associated invoices and settlements. Would you like to proceed?'));
        if (!success) {
          return
        }
        this.loading = true;
        let premiums = this.model.premiums.map(premium => premium.toJSON());
        let response = await this.saveTermsPartialData({
          premiums: premiums,
          minimum_premium: this.model.minimum_premium
        });
        this.loading = false;

        if (response.success) {
          await this.togglePremiumsModal(false);
          this.$toast('success', this.$t('Premiums were successfully saved'));
        } else {
          if (response.body.non_field_errors) {
            this.$errorDialog(response.body.non_field_errors[0]);
          } else if (response.toastError) {
            this.$errorDialog(response.toastError);
          } else {
            for (let index in response.body.premiums) {
              this.model.premiums[index].setMultipleErrors(response.body.premiums[index]);
            }
          }
        }
      },
      onHidden() {
        this.model = {};
        this.togglePremiumsModal(false);
      },
      onShow() {
        this.$nextTick(() => {
          this.model = new PremiumsFormData({
            premiums: _.cloneDeep(this.termDataPremiums),
            minimum_premium: this.termDataMinimumPremium
          });
        });
      },
    },
    computed: {
      ...mapState({
        showPremiumsModal: state => state.view.termsData.premiumsModal.show,
        termDataPremiums: state => state.view.termsData.premiums,
        termDataMinimumPremium: state => state.view.termsData.minimum_premium
      }),
    }
  }
</script>

<style lang="scss" scoped>
</style>

